import { createAction, props } from '@ngrx/store';
import { MerchantDetails } from '../model/auth.model';
export const loadMerchantDetails = createAction('[Merchant] Load Merchant Details');
export const loadMerchantDetailsSuccess = createAction('[Merchant] Load Merchant Details Success', props<{ merchant: any }>());
export const loadMerchantDetailsFailure = createAction('[Merchant] Load Merchant Details Failure', props<{ error: any }>());

export const loadReserveFund = createAction('[Merchant] Load Reserve Fund', props<{ merchantKeyId: number }>());
export const loadReserveFundSuccess = createAction('[Merchant] Load Reserve Fund Success', props<{ reserveFund: boolean }>());
export const loadReserveFundFailure = createAction('[Merchant] Load Reserve Fund Failure', props<{ error: any }>());

export const checkMerchantKeyId = createAction('[Merchant] Check Merchant Key ID', props<{ merchantKeyId: number, resellerId: number }>());
export const checkMerchantKeyIdSuccess = createAction('[Merchant] Check Merchant Key ID Success', props<{ success: number }>());
export const checkMerchantKeyIdFailure = createAction('[Merchant] Check Merchant Key ID Failure', props<{ error: any }>());

export const getQRCode = createAction('[Merchant] Get QR Code', props<{ merchantKeyId: number }>());
export const getQRCodeSuccess = createAction('[Merchant] Get QR Code Success', props<{ QRlink: any }>());
export const getQRCodeFailure = createAction('[Merchant] Get QR Code Failure', props<{ error: any }>());

export const getUserPermissions = createAction('[Merchant] Get User Permissions', props<{ userId: string, appName: string }>());
export const getUserPermissionsSuccess = createAction('[Merchant] Get User Permissions Success', props<{ permissions: any }>());
export const getUserPermissionsFailure = createAction('[Merchant] Get User Permissions Failure', props<{ error: any }>());

export const loadTransactionDetailsCount = createAction(
  '[Merchant] Load Transaction Details Count',
  props<{ fromDate: string; toDate: string }>()
);

export const loadTransactionDetailsCountSuccess = createAction(
  '[Merchant] Load Transaction Details Count Success',
  props<{ response: any }>()
);

export const loadTransactionDetailsCountFailure = createAction(
  '[Merchant] Load Transaction Details Count Failure',
  props<{ error: any }>()
);

export const loadEsignProcessStatus = createAction('[Merchant] Load Esign Process Status');
export const loadEsignProcessStatusSuccess = createAction('[Merchant] Load Esign Process Status Success', props<{ response: any }>());
export const loadEsignProcessStatusFailure = createAction('[Merchant] Load Esign Process Status Failure', props<{ error: any }>());

export const loadPaymentLink = createAction('[Merchant] Load Payment Link');
export const loadPaymentLinkSuccess = createAction('[Merchant] Load Payment Link Success', props<{ response: any }>());
export const loadPaymentLinkFailure = createAction('[Merchant] Load Payment Link Failure', props<{ error: any }>());

export const loadLatestMerchantSalesContact = createAction('[Merchant] Load Latest Merchant Sales Contact');
export const loadLatestMerchantSalesContactSuccess = createAction('[Merchant] Load Latest Merchant Sales Contact Success', props<{ response: any }>());
export const loadLatestMerchantSalesContactFailure = createAction('[Merchant] Load Latest Merchant Sales Contact Failure', props<{ error: any }>());


export const resetMerchantState = createAction('[Merchant] Reset State');